import http from './http';

export default {
  getJWT() {
    return http().get(`/v1/signal_wire/jwt`);
  },
  refreshJWT(data) {
    return http().post(`/v1/signal_wire/jwt/refresh`, data);
  },
  availableNumbers(area_code) {
    return http().get(`/v1/signal_wire/available_numbers?area_code=${area_code}`);
  },
  purchaseNumber(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/signal_wire/purchase_number`, data);
  },
  uploadVoiceMailRecording(data) {
    return http().put(`/v1/signal_wire/${data.id}/upload_voicemail_recording`, data);
  },
}
